import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { Container } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import './styles/global.css';

// Import pages
import HomePage from './pages/HomePage';
import LoginPage from './pages/LoginPage';
import SignupPage from './pages/SignupPage';
import BusinessDashboard from './pages/BusinessDashboard';
import ServicesPage from './pages/ServicesPage';
import AppointmentsPage from './pages/AppointmentsPage';
import AvailabilityPage from './pages/AvailabilityPage';
import NotificationsPage from './pages/NotificationsPage';
import PublicBookingPage from './pages/PublicBookingPage';
import BookingConfirmationPage from './pages/BookingConfirmationPage';
import SubscriptionPage from './pages/SubscriptionPage';
import CalendarPage from './pages/CalendarPage';
import AnalyticsPage from './pages/AnalyticsPage';
import QuickBooksPage from './pages/QuickBooksPage';
import SettingsPage from './pages/SettingsPage';
import UsersPage from './pages/UsersPage';
import VerifyEmailPage from './pages/VerifyEmailPage';
import TermsOfServicePage from './pages/TermsOfServicePage';
import PrivacyPolicyPage from './pages/PrivacyPolicyPage';

// Import components
import Header from './components/Header';
import Footer from './components/Footer';
import PrivateRoute from './components/PrivateRoute';
import BusinessRoute from './components/BusinessRoute';

function App() {
  return (
    <div className="app-container">
      <Header />

      <main className="main-content">
        <Container fluid="md" className="px-4 py-3">
          <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/login" element={<LoginPage />} />
              <Route path="/signup" element={<SignupPage />} />
              <Route path="/verify-email" element={<VerifyEmailPage />} />
              <Route path="/terms-of-service" element={<TermsOfServicePage />} />
              <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />

              {/* Public booking routes */}
              <Route path="/book/:businessId" element={<PublicBookingPage />} />
              <Route path="/confirmation" element={<BookingConfirmationPage />} />

              {/* Protected business routes */}
              <Route path="/dashboard" element={
                <PrivateRoute>
                  <BusinessRoute>
                    <BusinessDashboard />
                  </BusinessRoute>
                </PrivateRoute>
              } />
              <Route path="/services" element={
                <PrivateRoute>
                  <BusinessRoute>
                    <ServicesPage />
                  </BusinessRoute>
                </PrivateRoute>
              } />
              <Route path="/appointments" element={
                <PrivateRoute>
                  <BusinessRoute>
                    <AppointmentsPage />
                  </BusinessRoute>
                </PrivateRoute>
              } />
              <Route path="/availability" element={
                <PrivateRoute>
                  <BusinessRoute>
                    <AvailabilityPage />
                  </BusinessRoute>
                </PrivateRoute>
              } />
              <Route path="/notifications" element={
                <PrivateRoute>
                  <BusinessRoute>
                    <NotificationsPage />
                  </BusinessRoute>
                </PrivateRoute>
              } />
              <Route path="/dashboard/subscription" element={
                <PrivateRoute>
                  <BusinessRoute>
                    <SubscriptionPage />
                  </BusinessRoute>
                </PrivateRoute>
              } />
              <Route path="/dashboard/subscription/success" element={
                <PrivateRoute>
                  <BusinessRoute>
                    <SubscriptionPage />
                  </BusinessRoute>
                </PrivateRoute>
              } />
              <Route path="/dashboard/calendar" element={
                <PrivateRoute>
                  <BusinessRoute>
                    <CalendarPage />
                  </BusinessRoute>
                </PrivateRoute>
              } />
              <Route path="/dashboard/analytics" element={
                <PrivateRoute>
                  <BusinessRoute>
                    <AnalyticsPage />
                  </BusinessRoute>
                </PrivateRoute>
              } />
              <Route path="/dashboard/quickbooks" element={
                <PrivateRoute>
                  <BusinessRoute>
                    <QuickBooksPage />
                  </BusinessRoute>
                </PrivateRoute>
              } />
              <Route path="/dashboard/settings" element={
                <PrivateRoute>
                  <BusinessRoute>
                    <SettingsPage />
                  </BusinessRoute>
                </PrivateRoute>
              } />
              <Route path="/dashboard/users" element={
                <PrivateRoute>
                  <BusinessRoute>
                    <UsersPage />
                  </BusinessRoute>
                </PrivateRoute>
              } />
          </Routes>
        </Container>
      </main>

      <Footer />
    </div>
  );
}

export default App;
